import {
  ApiEmailAddressOptionsViewModel,
  ApiResult,
  ApiUpdateEmailAddressViewModel,
} from 'api'
import { AxiosResponse } from 'axios'
import { useApiClient } from './useApiClient'

export const useProfileApi = () => {
  const apiClient = useApiClient()

  const updateOwnEmailAddress = (data: ApiUpdateEmailAddressViewModel) => {
    return apiClient.request<void, AxiosResponse<void>>({
      url: `api/profile/self/emailAddress`,
      method: 'post',
      withCredentials: true,
      data,
    })
  }

  const getOwnEmailAddressOptions = () => {
    return apiClient.request<
      void,
      AxiosResponse<ApiResult<ApiEmailAddressOptionsViewModel>>
    >({
      url: `api/profile/self/emailAddress`,
      method: 'get',
      withCredentials: true,
    })
  }

  return {
    updateOwnEmailAddress,
    getOwnEmailAddressOptions,
  }
}
